import {
  ApplicationRef,
  Injectable,
  Injector,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef
} from '@angular/core';

import { LoadingBackdropComponent } from './loading-backdrop.component';
import { LoadingComponent } from './loading.component';

import { LoadingConfig } from './loading-config';
import { PromiseTrackerService } from './promise-tracker.service';

import { Subject, Subscription } from 'rxjs';

@Injectable()
export class LoadingService {
  private _backdropFactory: ComponentFactory<LoadingBackdropComponent>;
  private _loadingFactory: ComponentFactory<LoadingComponent>;
  private _fakeBusy: Subscription | Promise<any>;
  public backdropCmptRef: ComponentRef<LoadingBackdropComponent>;
  public loadingCmptRef: ComponentRef<LoadingComponent>;

  constructor(
    private _applicationRef: ApplicationRef,
    private _injector: Injector,
    private tracker: PromiseTrackerService,
    _componentFactoryResolver: ComponentFactoryResolver
  ) {
    this._backdropFactory = _componentFactoryResolver.resolveComponentFactory(
      LoadingBackdropComponent
    );
    this._loadingFactory = _componentFactoryResolver.resolveComponentFactory(
      LoadingComponent
    );

    let options = this.normalizeOptions(null);
    this.tracker.reset({
      promiseList: options.busy,
      delay: options.delay,
      minDuration: options.minDuration,
      onActivateTick: options.onActivateTick,
    });
    const containerEl = document.querySelector('body');

    let backdropCmptRef: ComponentRef<LoadingBackdropComponent>;
    let loadingCmptRef: ComponentRef<LoadingComponent>;

    // create backdrop
    backdropCmptRef = this._backdropFactory.create(this._injector);
    this._applicationRef.attachView(backdropCmptRef.hostView);
    containerEl.appendChild(backdropCmptRef.location.nativeElement);

    // create loading
    loadingCmptRef = this._loadingFactory.create(this._injector);
    this._applicationRef.attachView(loadingCmptRef.hostView);
    containerEl.appendChild(loadingCmptRef.location.nativeElement);
    const instance = loadingCmptRef.instance;
    instance.message = options.message;
    instance.wrapperClass = options.wrapperClass;

    this.backdropCmptRef = backdropCmptRef;
    this.loadingCmptRef = loadingCmptRef;
    (<HTMLElement>this.backdropCmptRef.location.nativeElement).style.position = 'relative';
    (<HTMLElement>this.loadingCmptRef.location.nativeElement).style.position = 'relative';
    // this.backdropCmptRef.location.nativeElement.style.zIndex = 2000;
    // this.loadingCmptRef.location.nativeElement.style.zIndex = 2001;
  }
  open(options = undefined) {
    options = this.normalizeOptions(options);
    if (options.busy.length === 0) {
      this._fakeBusy = new Subject().subscribe();
      this._fakeBusy = new Promise(resolve => {
        if (options.maxDuration)
          setTimeout(() => resolve(), options.maxDuration);
      });
      options.busy.push(this._fakeBusy);
    } else if (this._fakeBusy) {
      this._fakeBusy = null;
    }
    this.tracker.reset({
      promiseList: options.busy,
      delay: options.delay,
      minDuration: options.minDuration,
      onActivateTick: options.onActivateTick,
    });
    const instance = this.loadingCmptRef.instance;
    instance.message = options.message;
    instance.wrapperClass = options.wrapperClass;
    if (options.onActivateTick === true) this._applicationRef.tick();
    this.zIndex(options.zIndex);    
    return this.loadingCmptRef;
  }
  update(options) {
    options = this.normalizeOptions(options);
    const instance = this.loadingCmptRef.instance;
    if (options.message) instance.message = options.message;
    if (options.wrapperClass) instance.wrapperClass = options.wrapperClass;
    if (options.onActivateTick === true) this._applicationRef.tick();
    return this.loadingCmptRef;
  }
  close() {
    if (this._fakeBusy) this._fakeBusy = null;
    let options = this.normalizeOptions(undefined);
    this.tracker.reset({
      promiseList: options.busy,
      delay: options.delay,
      minDuration: options.minDuration,
      onActivateTick: options.onActivateTick,
    });
    const instance = this.loadingCmptRef.instance;
    instance.message = options.message;
    instance.wrapperClass = options.wrapperClass;
    if (options.onActivateTick === true) this._applicationRef.tick();
    return this.loadingCmptRef;
  }
  zIndex(zIndex: number = 2000) {
    this.backdropCmptRef.location.nativeElement.style.zIndex = zIndex;
    this.loadingCmptRef.location.nativeElement.style.zIndex = zIndex + 1;
  }

  private normalizeOptions(options: any) {
    if (!options) {
      options = { busy: null };
    } else if (
      Array.isArray(options) ||
      options instanceof Promise ||
      options instanceof Subscription
    ) {
      options = { busy: options };
    }
    options = Object.assign({}, new LoadingConfig(), options);
    if (!Array.isArray(options.busy)) {
      options.busy = options.busy ? [options.busy] : [];
    }

    return options;
  }
}
